import React from "react";

export const Cell = ({ className, style, children, ...props }) => {
  return (
    <div className={`c-table--td ${className}`} style={{...style, border: "0.5px solid #CCD5DA",}} {...props}>
      {children}
    </div>
  );
};
